module.exports = __webpack_public_path__ + "img/Regenwald.95ac2589.svg";